import React from "react";

export interface ServingPillType {
  percentage?: number;
  energyKj?: number;
  energyKcal?: number;
  title?: string;
  energyGram?: number;
  color?: string;
}

export const ServingPill = (props: ServingPillType) => {
  const { percentage, color, title, energyGram, energyKcal, energyKj } = props;
  return (
    <div className="serving__pill">
      <div className="serving__pill-nutrient">
        <div className="serving__pill-title">{title}</div>
        {energyGram !== undefined && (
          <div className="serving__pill-gram">
            <span className="serving__pill-gram-integer">{energyGram}</span>g
          </div>
        )}
        {energyKcal !== undefined && energyKj !== undefined && (
          <div className="serving__pill-energy">
            <div>
              <span className="serving__pill-energy-integer">{energyKj} </span>
              kJ
            </div>
            <div>
              <span className="serving__pill-energy-integer">
                {energyKcal}{" "}
              </span>
              kcal
            </div>
          </div>
        )}
      </div>
      {percentage !== undefined && (
        <div className="serving__pill-percentage" style={{ background: color }}>
          <span className="serving__pill-integer">{percentage}</span>%
        </div>
      )}
    </div>
  );
};
